var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectIsBuildingDestructible, selectIsBuildingPlaceable, selectIsBuildingPlacedTemporarily, selectIsBuildingStoreable, selectSelectedBuildingIsProducing, selectSelectedBuildingIsUpdating, } from "../../selectors/selectExistingBuildingInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdEventSoundCore } from "../../utils/sound/IdEventSoundCore";
import { ButtonHudNormal } from "../generic/common/ButtonHudNormal";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { TypeBuildingAction } from "../player-base/buildings/reducerBuildings";
import { IdTooltipAnchor, TooltipText } from "../tooltip";
import { IdTutorialFocusElement } from "../tutorial/IdTutorialFocusElement";
// TODO: needs refactoring
var PlacementModeButtonsDOM = /** @class */ (function (_super) {
    __extends(PlacementModeButtonsDOM, _super);
    function PlacementModeButtonsDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getBuildingButtonCancel = function () {
            var _a = _this.props, onCancelMove = _a.onCancelMove, onCancelPlacement = _a.onCancelPlacement, onCancelUnstore = _a.onCancelUnstore, buildingAction = _a.buildingAction;
            var onClick;
            if (buildingAction === TypeBuildingAction.Construct) {
                onClick = onCancelPlacement;
            }
            else if (buildingAction === TypeBuildingAction.Move) {
                onClick = onCancelMove;
            }
            else {
                onClick = onCancelUnstore;
            }
            return (React.createElement(TooltipText, { id: IdLoca.cancel, anchor: IdTooltipAnchor.Bottom },
                React.createElement(ButtonHudNormal, { onClick: onClick },
                    React.createElement("div", { className: "flex flex--guts w100 h100" },
                        React.createElement(Icon, { icon: IdIcon.CancelIcn, styleId: IdStyles.IconMedium })))));
        };
        _this.getBuildingButtonStore = function () {
            var _a = _this.props, onStore = _a.onStore, building = _a.building;
            return (React.createElement(ButtonHudNormal, { onClick: function () { return onStore(building); } },
                React.createElement("div", { className: "flex flex--guts w100 h100" },
                    React.createElement(Icon, { icon: IdIcon.InventoryIcn, styleId: IdStyles.IconMedium }))));
        };
        _this.getBuildingButtonDemolish = function () {
            var _a = _this.props, onDemolish = _a.onDemolish, building = _a.building, isProducingOrUpdating = _a.isProducingOrUpdating;
            return (React.createElement(TooltipText, { id: IdLoca.tooltip_demolish_web, anchor: IdTooltipAnchor.Bottom },
                React.createElement(ButtonHudNormal, { onClick: function () { return onDemolish(building); }, disabled: isProducingOrUpdating },
                    React.createElement("div", { className: "flex flex--guts w100 h100" },
                        React.createElement(Icon, { icon: IdIcon.DemolishIcn, styleId: IdStyles.IconMedium })))));
        };
        _this.getBuildingButtonRotate = function () {
            var _a = _this.props, onRotateMove = _a.onRotateMove, onRotatePlacement = _a.onRotatePlacement, onRotateUnstore = _a.onRotateUnstore, building = _a.building, buildingAction = _a.buildingAction;
            var onClick;
            if (buildingAction === TypeBuildingAction.Construct) {
                onClick = onRotatePlacement;
            }
            else if (buildingAction === TypeBuildingAction.Move) {
                onClick = onRotateMove;
            }
            else {
                onClick = onRotateUnstore;
            }
            return (React.createElement(TooltipText, { id: IdLoca.tooltip_rotate_web, anchor: IdTooltipAnchor.Bottom },
                React.createElement(ButtonHudNormal, { onClick: function () { return onClick(building); } },
                    React.createElement("div", { className: "flex flex--guts w100 h100" },
                        React.createElement(Icon, { icon: IdIcon.RotateIcn, styleId: IdStyles.IconMedium })))));
        };
        _this.getBuildingButtonFinish = function () {
            var _a = _this.props, onFinishPlace = _a.onFinishPlace, onFinishMove = _a.onFinishMove, onFinishUnstore = _a.onFinishUnstore, building = _a.building, buildingAction = _a.buildingAction, premium = _a.premium;
            var onClick;
            if (buildingAction === TypeBuildingAction.Construct) {
                onClick = function () { return onFinishPlace(building, premium); };
            }
            else if (buildingAction === TypeBuildingAction.Move) {
                onClick = function () { return onFinishMove(building, premium); };
            }
            else {
                onClick = function () { return onFinishUnstore(building); };
            }
            return (React.createElement(TooltipText, { id: IdLoca.confirm, anchor: IdTooltipAnchor.Bottom },
                React.createElement(ButtonHudNormal, { onClick: onClick },
                    React.createElement("div", { id: IdTutorialFocusElement.button_building_placement, className: "flex flex--guts w100 h100" },
                        React.createElement(Icon, { icon: IdIcon.CheckIcn, styleId: IdStyles.IconMedium })))));
        };
        _this.getBuildingButtonMove = function () {
            var _a = _this.props, onStartMove = _a.onStartMove, onStartPlacement = _a.onStartPlacement, onStartUnstore = _a.onStartUnstore, building = _a.building, buildingAction = _a.buildingAction, premium = _a.premium;
            var onClick;
            if (buildingAction === TypeBuildingAction.Construct) {
                onClick = function () { return onStartPlacement(building, premium); };
            }
            else if (buildingAction === TypeBuildingAction.Move) {
                onClick = function () { return onStartMove(building); };
            }
            else {
                onClick = function () { return onStartUnstore(building); };
            }
            return (React.createElement(TooltipText, { id: IdLoca.tooltip_move_web, anchor: IdTooltipAnchor.Bottom },
                React.createElement(ButtonHudNormal, { onClick: onClick, soundId: IdEventSoundCore.None },
                    React.createElement(Icon, { icon: IdIcon.MoveIcn, styleId: IdStyles.IconMedium }))));
        };
        return _this;
    }
    PlacementModeButtonsDOM.prototype.render = function () {
        var _a = this.props, isStorable = _a.isStorable, isDestructible = _a.isDestructible, isPlacedTemporarily = _a.isPlacedTemporarily, isPlaceable = _a.isPlaceable;
        var buildingButtonCancel = this.getBuildingButtonCancel();
        var buildingButtonStore = isStorable ? this.getBuildingButtonStore() : undefined;
        var buildingButtonDemolish = isDestructible
            ? this.getBuildingButtonDemolish()
            : undefined;
        var buildingButtonRotate = this.getBuildingButtonRotate();
        var buildingButtonMove = isPlacedTemporarily ? this.getBuildingButtonMove() : undefined;
        var buildingButtonFinish = isPlacedTemporarily && isPlaceable ? this.getBuildingButtonFinish() : undefined;
        var className = IdStyles.HudFooterBackground + " wooden-texture-background hud-player-base-navigation flex flex--aligned flex--spaced placement-mode-buttons-panel";
        return (React.createElement("div", { className: className },
            buildingButtonCancel,
            buildingButtonDemolish,
            buildingButtonRotate,
            buildingButtonStore,
            buildingButtonMove,
            buildingButtonFinish));
    };
    return PlacementModeButtonsDOM;
}(React.Component));
var mapState = function (state) { return ({
    isDestructible: selectIsBuildingDestructible(state),
    isPlaceable: selectIsBuildingPlaceable(state),
    isPlacedTemporarily: selectIsBuildingPlacedTemporarily(state),
    isProducingOrUpdating: selectSelectedBuildingIsProducing(state) || selectSelectedBuildingIsUpdating(state),
    isStorable: selectIsBuildingStoreable(state),
}); };
export var PlacementModeButtons = connect(mapState)(PlacementModeButtonsDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/navigation/PlacementModeButtons.tsx
// module id = 2272
// module chunks = 3